import loadable from "@loadable/component";
import { inject } from "mobx-react";
import type { Store } from "@inferno/renderer-shared-core";
import { Remote } from "../../components/remote/Remote.component";
import { getCurrentConditions, getSevenDayForecast } from "../../services/Weather";
import type { PageBlockInterface } from "../Block.component";

const Weather = loadable(() => import("./Weather.component"));

interface WeatherLoaderProps extends PageBlockInterface {
  store?: Store;
}

export const WeatherLoader = inject("store")(({ params, store, isPrimary, block }: WeatherLoaderProps) => {
  if (!store) {
    return null;
  }

  if (!params) {
    params = {};
  }

  // override params to siteconfig value
  const lat = params.geo_latitude || store.site.sections.general?.geo_latitude || null;
  const lon = params.geo_longitude || store.site.sections.general?.geo_longitude || null;

  if (lat === null || lon === null) {
    return null;
  }
  const baseUri = store.env.WEATHER_BASE_URI || "";
  const apiKey = store.env.WEATHER_API_KEY || "";
  const cacheKey = `weatherloader-${lat}-${lon}`;

  const tileLoader = false;

  return (
    <Remote
      cacheKey={cacheKey}
      loader={async () =>
        Promise.all([
          getCurrentConditions({ lat, lon, baseUri, apiKey, tileLoader }),
          getSevenDayForecast({ lat, lon, baseUri, apiKey, tileLoader }),
        ])
      }
      showLoading={isPrimary}
    >
      {({ data }) => {
        if (!data) {
          return null;
        }

        const [current, forecast] = data;
        return <Weather block={block} weather={current} forecast={forecast} />;
      }}
    </Remote>
  );
});

export default WeatherLoader;
